import gql from 'graphql-tag'

export const GET_ALL_WITH_PAGINATION = gql`
  query pieceworksWithPagination ($first: Int!, $page: Int!, $filters: FilterPiecework) {
    pieceworksWithPagination(first: $first, page: $page, filters: $filters) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        date
        is_wage
        headquarter_id
        area_id
        headquarter {
          name
        }
        area {
          name
        }
      }
    }
  }
`

export const GET_BY_ID = gql`
  query piecework ($id: ID!) {
    piecework (id: $id) {
      id
      headquarter_id
      area_id
      headquarter {
        id
        name
      }
      date
      is_wage
      salary_cap
      workdescriptions_total
      piecework_work_descriptions {
        id
        piecework_id
        work_description_id
        workDescription {
          id
          name
          price
          is_active
          is_group_piecework
          status_text
        }
        total
        price
        amount_total
      }
      piecework_items {
        id
        piecework_id
        employee_id
        employee {
          id
          name
          last_name
          fullName
          document_type
          document_number
          mothers_last_name
          assignment {
            work_shift_id
            work_shift {
              id
              name
              checkin_time
              checkout_time
              lunch_time_entry
              lunch_time_ends
              is_cumulative
              is_nocturnal
            }
          }
          cessation {
              id
              employee_id
              reason_id
              reason {
                id
                name
              }
              date
              type
              description
          }
        }
        task_id
        task_item_id
        time_in_device
        time_out_device
        time_in
        time_out
        total_hours
        participation
        amount_piecework
        daily
        regularization
        amount_to_pay
        time_total_extra_day_25
        time_total_extra_day_35
        time_total_nocturnal
        time_total_extra_nocturnal_25
        time_total_extra_nocturnal_35
        condition
        work_type
        is_support
        lunch
        ajeno
        lunch_rate_id
        amount_lunch
        price_lunch
        work_modality
        work_shift_id
        checkin_time
        checkout_time
        lunch_time_entry
        lunch_time_ends
        is_cumulative
        is_nocturnal
        time_lunch
        lunch_rate {
          name
          price
        }
        observations
        permission_control_piecework {
          id
          piecework_item_id
          permission_control_id
          reason_id
          reason {
            id
            description
            abbreviated
            type
            is_active
            status_text
            has_subsidy
            apply_sunday_discount
          }
          employee_id
          employee {
            id
            name
          }
          date_end
          date_start
          observations
        }
      }
    }
  }
`

export const EXISTS = gql`
  query PieceworkExists($date: Date!, $headquarter: ID!, $area: ID!, $type: Boolean!) {
    pieceworkExists(date: $date, headquarter: $headquarter, area: $area, type: $type) {
      exists
      id
    }
  }
`

export const CREATE_PIECEWORK = gql`
  mutation createPiecework ($input: PieceworkInput!) {
    createPiecework(input: $input) {
      id
    }
  }
`

export const UPDATE_PIECEWORK = gql`
  mutation updatePiecework ($id: ID!, $input: PieceworkInput!) {
    updatePiecework (id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_PIECEWORK = gql`
  mutation deletePiecework ($id: ID!) {
    deletePiecework(id: $id) {
      id
    }
  }
`
